import { ytReady } from './youtube';
import { attachYouTubeAnalyticsEvents } from '../analytics/analytics';

// Main component classes
const thirdPartyVideoClass = 'ThirdPartyVideo';
const inlineVideoClass = 'InlineVideo';

// Selectors
const selectors = {
	placeholder: `.${inlineVideoClass}-placeholder`,
	video: `.${inlineVideoClass}-video`,
	thirdPartyVideo: `.${thirdPartyVideoClass}`,
	thirdPartyVideoDiv: `.${thirdPartyVideoClass} > div`,
	thirdPartyVideoIFrame: `.${thirdPartyVideoClass} > iframe`,
};

const youtubePlayers = {};

// Call YouTube API
const initializeYoutube = inlineVideo => {
	if (inlineVideo) {
		// Get video element
		const thirdPartyVideoDiv = inlineVideo.querySelector(selectors.thirdPartyVideoDiv);

		if (thirdPartyVideoDiv) {
			const divId = thirdPartyVideoDiv.getAttribute('id');
			const videoId = thirdPartyVideoDiv.dataset.videoId;

			if (divId && videoId) {
				// Initialize YouTube video
				ytReady(() => {
					youtubePlayers[divId] = new YT.Player(divId, {
						host: 'https://www.youtube-nocookie.com',
						playerVars: {
							enablejsapi: 1,
							origin: document.domain,
							rel: 0,
						},
						width: '100%',
						height: `100%`,
						videoId: videoId,
						events: {
							onReady: attachYouTubeAnalyticsEvents,
						},
					});
				});
			}
		}
	}
};

const resizeVideo = inlineVideo => {
	if (inlineVideo) {
		// Get video element. Either the initial div..
		let thirdPartyVideoElement = inlineVideo.querySelector(selectors.thirdPartyVideoDiv);
		// ... or the resulting iFrame
		if (!thirdPartyVideoElement) {
			thirdPartyVideoElement = inlineVideo.querySelector(selectors.thirdPartyVideoIFrame);
		}

		const placeholder = document.querySelector(selectors.placeholder);
		let placeholderHeight = placeholder.clientHeight;

		if (placeholderHeight > 0) {
			thirdPartyVideoElement.style.height = placeholderHeight + 'px';
		} else {
			let w = thirdPartyVideoElement.clientWidth;
			let newWidth = w * math.div(9, 16);
			thirdPartyVideoElement.style.height = newWidth + 'px';
		}
	}
};

export default function inlineVideo() {
	const inlineVideos = Array.from(document.querySelectorAll(selectors.video));

	inlineVideos.forEach(function (inlineVideo) {
		resizeVideo(inlineVideo);
		initializeYoutube(inlineVideo);

		window.addEventListener('resize', function () {
			resizeVideo(inlineVideo);
		});

		let placeholder = inlineVideo.previousElementSibling;

		placeholder.addEventListener('click', function () {
			placeholder.style.display = 'none';
			inlineVideo.style.display = 'block';

			let thirdPartyVideoElement = inlineVideo.querySelector(selectors.thirdPartyVideoDiv);
			if (!thirdPartyVideoElement) {
				thirdPartyVideoElement = inlineVideo.querySelector(selectors.thirdPartyVideoIFrame);
			}

			const divId = thirdPartyVideoElement.getAttribute('id');

			if (youtubePlayers[divId]) {
				youtubePlayers[divId].playVideo();
			}
		});
	});
}
